import axios from '../lib/axios'
import Bugsnag from './Bugsnag'
import AuthenticationService from '../services/AuthenticationService'
import Store from '../store/Store'
import moment from 'moment'

const url = process.env.ZLICK_V2

export default {
  search: ({ searchQuery, page, limit }) => {
    if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) throw new Error('Permission denied. Cannot search transactions')
    let startDate
    let endDate
    if (searchQuery && searchQuery.dates) {
      if (searchQuery.dates.startDate) {
        startDate = moment(searchQuery.dates.startDate).startOf('date').toISOString()
      }
      if (searchQuery.dates.endDate) {
        endDate = moment(searchQuery.dates.endDate).endOf('date').toISOString()
      }
    }
    return axios.get(url + '/transactions/findByQuery', {
      params: {
        search: searchQuery ? searchQuery.searchValue : undefined,
        startDate,
        endDate,
        page: page,
        limit: limit,
        excludeFailure: true
      },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
      .catch((error) => {
        Bugsnag.send(error)
        throw new Error('Failed to query transactions ' + error)
      })
  },

  refund: ({ refundReason, transactionId }) => {
    if (!AuthenticationService.isInRole(['admin', 'support'])) throw new Error('Permission denied. Cannot refund')
    return axios.post(url + '/refund', { refundReason, transactionId }, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
      .catch((error) => {
        Bugsnag.send(error)
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/TransactionsService.js